import CheckBox from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlank from '@mui/icons-material/CheckBoxOutlineBlank';
import { Autocomplete, Checkbox, FormControl, TextField } from '@mui/material';
import { useAppSelector } from 'app/hooks';
import { AclResource } from 'common/types/Entities';
import { selectRawEntities } from 'features/aclResources/aclResourcesSlice';
import { useFetchAclsByTenantId } from 'features/reports/hooks/useFetchAclsByTenantId';

export function AclMultipleSelectDropDown(props: Readonly<{
    tenantId: string,
    value: AclResource[],
    onChange: (acls: AclResource[]) => void,
}>) {
    const { tenantId, value, onChange } = props;

    // Fetch ACLs when tenantId changes and store them in Redux
    useFetchAclsByTenantId(onChange, tenantId);

    // Get ACLs from Redux store
    const aclsFromStore = useAppSelector(selectRawEntities);
    const options = [...aclsFromStore];

    const handleChange = (_event: React.SyntheticEvent, newValue: AclResource[], reason: string) => {
        if (reason === 'selectOption' || reason === 'removeOption' || reason === 'clear') {
            onChange(newValue);
        }
    };

    return (
        <FormControl fullWidth>
            <Autocomplete
                disabled={!tenantId}
                value={value}
                onChange={handleChange}
                multiple
                options={options}
                disableCloseOnSelect
                getOptionLabel={opt => opt.displayName || opt.name}
                isOptionEqualToValue={(option, val) => option.id === val.id}
                noOptionsText={'ACL Resources not found for this tenant'}
                renderOption={(optionProps, option, { selected }) => {
                    const { key, ...restProps } = optionProps;
                    return (
                        <li key={key} {...restProps}>
                            <Checkbox
                                icon={<CheckBoxOutlineBlank fontSize={'small'} />}
                                checkedIcon={<CheckBox fontSize={'small'} />}
                                style={{ marginRight: '8px' }}
                                checked={selected}
                            />
                            {option.displayName || option.name}
                        </li>
                    );
                }}
                renderInput={params => (
                    <TextField
                        {...params}
                        label='ACL Resource'
                        placeholder={value.length === 0 && tenantId ? 'Select ACL Resources' : ''}
                    />
                )}
            />
        </FormControl>
    );
}
